import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { ApplicantStage } from "./config";

const STAGE_ROUTES: Record<number, string> = {
  [ApplicantStage.PanVerification]:      "/eligibility/income",
  [ApplicantStage.AddressDetails]:       "/eligibility/bank-statement",
  [ApplicantStage.EmploymentDetails]:    "/eligibility/bank-statement",
  [ApplicantStage.AwaitingApproval]:     "/eligibility/under-review",
  [ApplicantStage.Approved]:             "/eligibility/congratulations",
  [ApplicantStage.SanctionTermsAccepted]:"/eligibility/selfie",
  [ApplicantStage.Selfie]:               "/eligibility/agreement",
  [ApplicantStage.Agreement]:            "/eligibility/emandate",
  [ApplicantStage.BsDone]:               "/eligibility/digilocker",
  [ApplicantStage.FundSourceAssigned]:   "/eligibility/evaluating",
  [ApplicantStage.Rejected]:             "/eligibility/rejected",
};

export function useStageGuard(
  userId: string | undefined,
  applicationId: string | undefined,
  currentStage: number,
  skip: boolean = false
) {
  const navigate = useNavigate();

  useEffect(() => {
    if (skip) return;
    let uid = userId;
    let appId = applicationId;

    if (!uid || !appId) {
      const saved = JSON.parse(sessionStorage.getItem("eligibility_data") || "{}");
      uid = saved?.userId;
      appId = saved?.applicationId;
    }

    if (!uid || !appId) return;

    const token = sessionStorage.getItem("eligibility_auth_token");

    let cancelled = false;

    axios
      .get(
        `${process.env.REACT_APP_DASHBOARD_URL}/admin/application/stage?applicationId=${appId}`,
        { headers: { Authorization: `Bearer ${token}` } }
      )
      .then((res) => {
        if (cancelled) return;
        const stage: number = res?.data?.data?.stage;
        if (stage !== undefined && stage !== currentStage) {
          const navData = { userId: uid, applicationId: appId };
          if (stage === ApplicantStage.BsDone) {
            navigate("/eligibility/digilocker", { replace: true, state: { data: navData } });
          } else if (stage === ApplicantStage.BankStatement) {
            navigate("/eligibility/waiting", { replace: true, state: { data: navData, nextRoute: "/eligibility/digilocker" } });
          } else if (stage === ApplicantStage.Digilocker) {
            navigate("/eligibility/waiting", { replace: true, state: { data: navData, fromStage10: true } });
          } else if (STAGE_ROUTES[stage]) {
            navigate(STAGE_ROUTES[stage], { replace: true, state: { data: navData } });
          }
        }
      })
      .catch((e) => console.log("stage guard error:", e));

    return () => { cancelled = true; };
  }, [userId, applicationId]);
}
